{
  "salon-details-footer": {
    "text": {
      "contact-salon": "SALON-KONTAKTE",
      "closed": "Geschlossen",
      "opening-time": "ÖFFNUNGSZEIT",
      "salon-location": "SALON-STANDORT"
    }
  }
}
